import { render, staticRenderFns } from "./CardSliderImage.vue?vue&type=template&id=1cb8797c"
import script from "./CardSliderImage.vue?vue&type=script&lang=js"
export * from "./CardSliderImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports